const SNACKBAR_FIELD_LABELS: Record<string, string> = {
  vendor: "Third Party",
  vendorId: "Third Party",
  vendorName: "Third Party Name",
  vendorCategoryId: "Category",
  category: "Category",
  categoryId: "Category",
  productOwner: "Engagement Owner",
  productOwnerId: "Engagement Owner",
  approver1: "Approver 1",
  approver2: "Approver 2",
  departmentId: "Department",
  legalEntityId: "Legal Entity",
  businessUnitId: "Business Unit",
  workflowId: "Workflow",
  questionnaireId: "Questionnaire",
  engagementId: "Engagement",
  assessmentId: "Assessment",
  riskTieringId: "Risk Tiering",
  contractId: "Contract",
  contractTypeId: "Contract Type",
  contractOwnerId: "Contract Owner",
  roleId: "Role",
  userId: "User",
  firstName: "First Name",
  lastName: "Last Name",
};

const FALLBACK_SNACKBAR_ERROR = "Something went wrong. Please try again.";

const humanizeLabelList = (labels: string[]): string => {
  if (labels.length === 1) {
    return labels[0];
  }

  return `${labels.slice(0, -1).join(", ")} and ${labels[labels.length - 1]}`;
};

const getFieldLabel = (fieldName: string): string =>
  SNACKBAR_FIELD_LABELS[fieldName] || fieldName;

const normalizeMongooseRequiredFields = (message: string): string | null => {
  const requiredFieldPattern =
    /(?:^|[,\s])([A-Za-z][A-Za-z0-9_.$-]*)\s*:\s*Path\s+[`'"]?\1[`'"]?\s+is required\.?/g;
  const labels = Array.from(message.matchAll(requiredFieldPattern))
    .map((match) => getFieldLabel(match[1]))
    .filter(Boolean);
  const uniqueLabels = Array.from(new Set(labels));

  if (!uniqueLabels.length) {
    return null;
  }

  return uniqueLabels.length === 1
    ? `${uniqueLabels[0]} is required.`
    : `${humanizeLabelList(uniqueLabels)} are required.`;
};

export const normalizeSnackbarMessage = (message: unknown): string => {
  if (message === null || message === undefined) {
    return FALLBACK_SNACKBAR_ERROR;
  }

  let normalizedMessage =
    typeof message === "string" ? message : JSON.stringify(message);

  if (!normalizedMessage || normalizedMessage === "{}") {
    return FALLBACK_SNACKBAR_ERROR;
  }

  const requiredFieldsMessage = normalizeMongooseRequiredFields(normalizedMessage);
  if (requiredFieldsMessage) {
    return requiredFieldsMessage;
  }

  normalizedMessage = normalizedMessage.replace(
    /^[^:]+ validation failed:\s*/i,
    ""
  );

  Object.entries(SNACKBAR_FIELD_LABELS).forEach(([fieldName, label]) => {
    const pattern = new RegExp(`\\b${fieldName}\\b`, "g");
    normalizedMessage = normalizedMessage.replace(pattern, label);
  });

  normalizedMessage = normalizedMessage
    .replace(/Path\s+[`'"]([^`'"]+)[`'"]\s+is required\.?/gi, "$1 is required.")
    .replace(/\s+/g, " ")
    .trim();

  return normalizedMessage || FALLBACK_SNACKBAR_ERROR;
};
